import {useQuery} from 'react-query';
import {getCreditPayAvailableOptions} from './getCreditPayAvailableOptions';

const useGetCreditPayAvailableOptions = (enabled?: boolean) => {
  return useQuery(
    ['get-credit-pay-available-options'],
    () => getCreditPayAvailableOptions(),
    {
      enabled: enabled ?? true,
      select: data => ({
        ...data,
        totalCreditOptions: Number(data.has_credit) + Number(data.has_cashback),
        // TODO : ADD BNPL
        // + Number(data.has_bnpl),
      }),
    },
  );
};

export default useGetCreditPayAvailableOptions;
